import {Modal, createStyles} from '@mantine/core';
import classNames from 'classnames';
import React, {type ReactNode} from 'react';

interface ResultsPreviewModalProps {
  children: ReactNode;
  onClose: () => void;
  opened: boolean;
  wide: boolean;
}

export default function ResultsPreviewModal({
  children,
  onClose,
  opened,
  wide,
}: ResultsPreviewModalProps): JSX.Element {
  const {classes} = useStyles();

  return (
    <Modal
      opened={opened}
      onClose={onClose}
      title="Preview"
      closeButtonProps={{'aria-label': 'Close modal'}}
      size="xl"
      centered={true}
      withinPortal={true}
      classNames={{
        inner: classes.inner,
        content: classNames(classes.content, {[classes.wideContent]: wide}),
        body: classes.body,
      }}
    >
      <div className={classes.layout}>{children}</div>
    </Modal>
  );
}

const useStyles = createStyles((theme) => ({
  inner: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
  },
  content: {
    margin: 'auto',
    width: 'min(760px, 95vw)',
    maxWidth: '95vw',
  },
  wideContent: {
    width: 'min(1200px, 95vw)',
  },
  body: {
    paddingTop: theme.spacing.sm,
    paddingBottom: 0,
  },
  layout: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'stretch',
    gap: theme.spacing.lg,
    width: '100%',
  },
}));
